import { Fragment, PureComponent } from 'react';

import { Button } from 'components/Button/Button';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import handleEvent from 'utils/handleEvent';
import { noteChange } from './actions';
import { makeSelectSavingNote } from './selectors';

class Note extends PureComponent {
  static propTypes = {
    canEdit: PropTypes.bool.isRequired,
    msg: PropTypes.object.isRequired,
    onNoteChange: PropTypes.func.isRequired,
    savingNote: PropTypes.bool.isRequired,
    snapshot: ImmutablePropTypes.map.isRequired,
  };

  state = {
    edit: false,
    noteValue: '',
  };

  componentDidUpdate(prevProps) {
    const { savingNote } = this.props;
    if (prevProps.savingNote !== savingNote && !savingNote) {
      this.restoreState();
    }
  }

  restoreState = () => {
    this.setState({
      edit: false,
      noteValue: '',
    });
  };

  handleKeyDown = handleEvent((e) => {
    if ((e.ctrlKey || e.shiftKey) && e.keyCode === 13) {
      e.preventDefault();
      this.setState({ noteValue: `${this.state.noteValue}\n` });
    } else if (e.keyCode === 13) {
      this.saveNote();
    } else if (e.keyCode === 27) {
      this.restoreState();
    }
  });

  handleEditChange = handleEvent(() => {
    const { snapshot, canEdit } = this.props;
    if (!this.state.edit && canEdit) {
      this.setState({ edit: true, noteValue: snapshot.get('note') || '' });
    }
  });

  handleTitleChange = handleEvent(({ target: { value } }) => {
    this.setState({ noteValue: value });
  });

  saveNote = handleEvent(() => {
    const { snapshot, onNoteChange } = this.props;
    onNoteChange({
      id: snapshot.get('id'),
      previousNote: snapshot.get('note') || '',
      note: this.state.noteValue,
    });
  });

  render() {
    const { snapshot, msg, savingNote, canEdit } = this.props;
    const { edit, noteValue } = this.state;
    return (
      <Fragment>
        <div>
          <label htmlFor={undefined}>{get(msg, 'detail.note')}</label>
        </div>
        {edit ? (
          <div>
            <textarea
              className='form-control'
              value={noteValue}
              onChange={this.handleTitleChange}
              onKeyDown={this.handleKeyDown}
              onBlur={this.saveNote}
              autoFocus
              disabled={savingNote}
              rows={15}
            />
          </div>
        ) : (
          <div
            className={`snapshots-content-note__wrapper ${!canEdit || edit ? 'snapshots-content-note__wrapper--edit' : ''}`}
            onClick={this.handleEditChange}
          >
            <div
              className={`snapshots-content__text ${snapshot.get('note') ? 'snapshots-content__text--empty' : ''}`}
            >
              {(snapshot.get('note') || get(msg, 'detail.noteEmpty', 'Empty'))
                .split('\n')
                .map((row, i) => (
                  // biome-ignore lint/suspicious/noArrayIndexKey: legacy code, no better key there
                  <div className='snapshots-content-note__row' key={i}>
                    {row}
                  </div>
                ))}
            </div>
            {canEdit && (
              <Button
                variant='tertiary'
                size='xxs'
                icon='fa-pen'
                className='ml-2 mt-1'
              />
            )}
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  savingNote: makeSelectSavingNote(),
});

function mapDispatchToProps(dispatch) {
  return {
    onNoteChange: (args) => dispatch(noteChange(args)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Note);
